import { useToken } from "@packsize/authentication";

import { getSiteToken } from "@/api/identity-api";
import { companyUrl } from "@/environment";

import { ManageUsersButtonTemplate } from "./manage-users-button.template";

export const ManageUsersButton = () => {
	const { decodedToken } = useToken();

	const handleClick = async () => {
		if (decodedToken === null || decodedToken === undefined) {
			return;
		}

		const tokenResponse = await getSiteToken(decodedToken.tid);

		window.open(`${companyUrl}/users?token=${encodeURIComponent(tokenResponse.access_token)}`, "_blank");
	};

	return <ManageUsersButtonTemplate onClick={handleClick} />;
};
